"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = (function () {
    function State(config) {
        this.availableDurations = [
            {
                from: 1,
                id: 0,
                name: 'beliebig',
                shortName: 'beliebig',
                to: 9999,
            },
            {
                from: 1,
                id: 1,
                name: '1-5 Tage',
                shortName: '1-5 Tage',
                to: 5,
            },
            {
                from: 6,
                id: 6,
                name: '6-9 Tage',
                shortName: '6-9 Tage',
                to: 9,
            },
            {
                from: 10,
                id: 10,
                name: '10-13 Tage',
                shortName: '10-13 Tage',
                to: 13,
            },
            {
                from: 14,
                id: 14,
                name: '14-21 Tage',
                shortName: '14-21 Tage',
                to: 21,
            },
            {
                from: 22,
                id: 22,
                name: 'ab 22 Tage',
                shortName: 'ab 22 Tage',
                to: 99999,
            },
        ];
        this.availableRegions = [];
        this.carolCampaign = {
            campaignEnd: '',
            campaignStart: '',
            campaignTeaserPricesStart: '',
            contentSections: [],
            contentSectionsHeadline: '',
            createdAt: '',
            description: '',
            descriptionHtml: '',
            headerImage: {
                file: '',
                uid: '',
            },
            headline: '',
            id: '',
            specialOffers: [],
            subHeadline: '',
            tariffInformationDescription: '',
            tariffInformationDescriptionHtml: '',
            tariffInformationHeadline: '',
            teaserImage: {
                file: '',
                uid: '',
            },
            updatedAt: '',
        };
        this.config = config;
        this.filter = {
            depGermany: false,
            flightIncluded: false,
            priceModel: this.config.priceModel,
            region: 'NONE',
            travelDuration: 9999,
        };
        this.numberCruises = 0;
        this.searchResults = [];
        this.sortBy = {
            code: 'price',
            name: 'Sortieren nach Preis',
            shortName: 'Preis',
        };
        this.specialSortBy = {
            code: 'price',
            name: 'Sortieren nach Preis',
            shortName: 'Preis',
        };
        this.specialResults = [];
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map